const state = {
  pageType: "list",
  selectedData: {},
};
const mutations = {
  SET_PAGETYPE(state, val) {
    state.pageType = val;
  },
  SET_SELECTEDDATA(state, val) {
    state.selectedData = val;
  },
  INIT_ACTIVITY(state) {
    state.pageType = "list";
    state.selectedData = {};
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
